export function verificaTamanhoEmBytes(bytes: number): boolean {
  const umMBEmBytes = 1024 * 1024; // 1MB em bytes

  if (bytes > umMBEmBytes) {
    return true; // Excede 1MB
  }
  return false;
}
